var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":"","justify":"end"}},[_c('v-col',{attrs:{"shrink":""}},[_c('v-select',{attrs:{"light":"","items":_vm.sortOptions,"label":_vm.sortInputLabel,"value":_vm.sort,"hide-details":""},model:{value:(_vm.sort),callback:function ($$v) {_vm.sort=$$v},expression:"sort"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }